import { ReactElement } from 'react';

import { ReactComponent as AyotHero } from '@backrs_ui/common-ui/src/assets/images/ayot-hero.svg';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { UserProfileResponse } from '@backrs_ui/grow-ui/src/redux/profile/profile';

import { Box, SxProps, Theme } from '@mui/material';

import { AssessmentChecklist } from './AssessmentChecklist';
import { StandardsByTrackCard } from './StandardsByTrackCard';
import { ChecklistDataOverrides } from '../assessMyTrack.types';

const ASSESS_MY_TRACK_STRINGS = appStrings.modules.assessMyTrack;

type AssessmentEmptyStateProps = Readonly<{
  profileData: UserProfileResponse | undefined;
  checklistDataOverrides?: ChecklistDataOverrides;
  handleAssessMyTrack: () => void;
  isLoading: boolean;
  allowReassess: boolean;
  hasError?: boolean;
}>;

export const AssessmentEmptyState = ({
  profileData,
  checklistDataOverrides,
  handleAssessMyTrack,
  isLoading,
  allowReassess,
  hasError = false,
}: AssessmentEmptyStateProps): ReactElement => {
  return (
    <>
      <Box sx={heroImageSx}>
        <AyotHero style={heroSvgStyle} />
      </Box>
      <Box sx={checklistsContainerSx}>
        <AssessmentChecklist
          profileData={profileData}
          checklistDataOverrides={checklistDataOverrides}
          title={ASSESS_MY_TRACK_STRINGS.assessmentChecklist.title}
          description={ASSESS_MY_TRACK_STRINGS.assessmentChecklist.description}
          variant={{
            type: 'required',
            handleAssessMyTrack,
            isLoading,
            allowReassess,
            hasError,
          }}
        />
        <Box sx={rightColumnSx}>
          <AssessmentChecklist
            profileData={profileData}
            checklistDataOverrides={checklistDataOverrides}
            title={ASSESS_MY_TRACK_STRINGS.goTheExtraMile.title}
            description={ASSESS_MY_TRACK_STRINGS.goTheExtraMile.description}
            variant={{ type: 'optional' }}
          />
          <StandardsByTrackCard />
        </Box>
      </Box>
    </>
  );
};

const heroImageSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  borderRadius: backrs.radius['radius-xl'],
  overflow: 'hidden',
  border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
});

const heroSvgStyle: React.CSSProperties = {
  width: '100%',
  height: 'auto',
  display: 'block',
};

const checklistsContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: backrs.spacing['spacing-2xl'],
  width: '100%',
  '& > *': {
    flex: '1 1 400px',
  },
});

const rightColumnSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-2xl'],
  minWidth: 0,
});
